import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import App from './App';
import { isValidTenant } from './constants/tenant';
import PublicPage from './AHJ/PublicPage';
import { msalInstance, runWithMsal } from './authConfig';
import { MsalProvider } from '@azure/msal-react';
import { InvalidAccess } from './components/common/InvalidAccess';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './query/queryClient';

const root = ReactDOM.createRoot(document.getElementById('root'));

const publicRoute = [
	"/inspection"
];

const isPublicRoute = publicRoute.some(route => window.location.pathname.startsWith(route));

if (isPublicRoute) {
	root.render(
		<QueryClientProvider client={queryClient}>
      <BrowserRouter>
			<Routes>
				<Route path="/inspection" element={<PublicPage />}></Route>
			</Routes>
		</BrowserRouter>
		</QueryClientProvider>
	);
} else {
	 runWithMsal(msalInstance, () => {
		const profile = msalInstance.getAllAccounts()[0];
		const { idTokenClaims } = profile;
		const { tid } = idTokenClaims;

		if (isValidTenant({ tid })) {
			localStorage.setItem('user_profile', JSON.stringify(profile));
			root.render(
				<BrowserRouter>
					<MsalProvider instance={msalInstance}>
						<App />
					</MsalProvider>
				</BrowserRouter>
			);
		}
		else {
			root.render(<InvalidAccess level='tenant' />)

		}
	})
}
